import { TemperMark } from "./Logo";

export default function Marquee({ items = [] }) {
  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-display text-2xl font-bold tracking-tight text-ink/60 md:text-4xl">
            {it}
          </span>
          <TemperMark className="mx-8 h-3 w-3 text-ember md:mx-12" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="marquee" className="select-none overflow-hidden border-y border-line py-6 md:py-8">
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
